import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./styles.module.scss";
import { CTA, Description, Image, Title, Video } from "@/ui";

export const NarrativePanel = ({
  className,
  bgColor,
  textColor,
  title,
  titleColor,
  description,
  img,
  button,
  video_embed_url,
  reverse,
  paddingTop = "pt-5",
  paddingBottom = "pb-5",
}) => {
  if (!title && !description && !img) {
    return null;
  }

  // On mobile the text sits below the image, so "None" only removes the bottom padding from tablet up
  const bottom = paddingBottom === "pb-0" ? "pb-5 pb-md-0" : paddingBottom;

  return (
    <div className={cn(className, bgColor, textColor, styles.panel, paddingTop, bottom)}>
      <Container className="mw-xxl">
        <Row
          className={cn("flex-column-reverse", {
            "flex-md-row-reverse": reverse,
            "flex-md-row": !reverse,
          })}
        >
          <Col xs={12} md={video_embed_url || img ? 6 : 12} className="d-flex flex-column justify-content-center">
            <div className={video_embed_url || img ? "ms-md-5" : ""}>
              <Title title={title} className={cn(titleColor, "mb-3")} />
              <Description description={description} />
              {button
                ? button.map((btn, k) => (
                    <CTA
                      key={k}
                      label={btn.label}
                      href={btn.href}
                      className={cn("mt-4")}
                      variant={btn.variant}
                      target={btn.open_in_new_tab ? "_blank" : undefined}
                    />
                  ))
                : null}
            </div>
          </Col>
          {video_embed_url || img ? (
            <Col xs={12} md={6} className="d-flex flex-column justify-content-center">
              {video_embed_url ? (
                <Video video_embed_url={video_embed_url} />
              ) : img ? (
                <figure className="mb-4 mb-md-0">
                  <img className="d-block mw-100" src={img?.url} size="540x" alt="Narrative panel image" />
                </figure>
              ) : null}
            </Col>
          ) : null}
        </Row>
      </Container>
    </div>
  );
};

export default NarrativePanel;
